import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_VERANSTALTUNG_AKTIONEN2 = '[VeranstaltungenModul] GetVeranstaltungAktionen2 laden';
export const GET_VERANSTALTUNG_AKTIONEN2_AUSFUEHREN = '[VeranstaltungenModul] GetVeranstaltungAktionen2 ausführen';
export const GET_VERANSTALTUNG_AKTIONEN2_ERFOLGREICH = '[VeranstaltungenModul] GetVeranstaltungAktionen2 laden erfolgreich';
export const GET_VERANSTALTUNG_AKTIONEN2_FEHLER = '[VeranstaltungenModul] GetVeranstaltungAktionen2 Ladefehler';
export const GET_VERANSTALTUNG_AKTIONEN2_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetVeranstaltungAktionen2 nicht ausgeführt (evtl. Offline)';


export class GetVeranstaltungAktionen2Action implements Action {
    readonly type = GET_VERANSTALTUNG_AKTIONEN2;
        constructor( public veranstaltung_id:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungAktionen2AusfuehrenAction implements Action {
    readonly type = GET_VERANSTALTUNG_AKTIONEN2_AUSFUEHREN;
        constructor( public veranstaltung_id:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungAktionen2ErfolgreichAction implements Action {
    readonly type = GET_VERANSTALTUNG_AKTIONEN2_ERFOLGREICH;
        constructor(public payload: Array<api.Aktion>,  public veranstaltung_id:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungAktionen2FehlerAction implements Action {
    readonly type = GET_VERANSTALTUNG_AKTIONEN2_FEHLER;
        constructor(public payload: any,  public veranstaltung_id:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungAktionen2NichtAusgefuehrtAction implements Action {
    readonly type = GET_VERANSTALTUNG_AKTIONEN2_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryVeranstaltungAktionen2Actions =
    GetVeranstaltungAktionen2Action
    | GetVeranstaltungAktionen2AusfuehrenAction
    | GetVeranstaltungAktionen2ErfolgreichAction
    | GetVeranstaltungAktionen2FehlerAction
    | GetVeranstaltungAktionen2NichtAusgefuehrtAction
    ;
